import { FeatureDecisionService } from '../services/feature-decision/feature-decision.service';
import { BaseCondition } from './base-condition';

export class SwitchCondition implements BaseCondition {
  constructor(private readonly conditions: Array<BaseCondition>) {}

  isAllowed(service: FeatureDecisionService): boolean {
    return this.conditions.some(condition => service.evaluate(condition) === true);
  }
}
